import React from "react";
import ReactSelect from "react-select";

export class Select extends React.Component {
  render() {
    return <ReactSelect {...this.props} />;
  }
}
